import React from "react";

import { ACCESS_MODULES, AccessModule } from "../../../utils/accessModules";

type Props = {
  /** Módulos retirados. */
  value: AccessModule[];
  onChange: (next: AccessModule[]) => void;
  disabled?: boolean;
};

/**
 * Direitos do administrador restrito (ADR 0027): cada módulo da barra marcado é
 * um módulo que ele alcança; desmarcar retira. Mesmo visual do `ExtraRolesPicker`.
 */
const RevokedModulesPicker: React.FC<Props> = ({ value, onChange, disabled }) => {
  const toggle = (key: AccessModule) =>
    onChange(
      ACCESS_MODULES.map((m) => m.key).filter((m) => (m === key ? !value.includes(m) : value.includes(m))),
    );

  return (
    <div className="admFormGroup">
      <label>Direitos</label>
      <div className="admStorePicker__list">
        {ACCESS_MODULES.map((module) => (
          // O `.admFormGroup label` deixaria o nome em caixa alta.
          <label
            key={module.key}
            className="admStoreOption"
            style={{ textTransform: "none", letterSpacing: "normal", fontWeight: 400 }}
          >
            <input
              type="checkbox"
              checked={!value.includes(module.key)}
              disabled={disabled}
              onChange={() => toggle(module.key)}
            />
            <span className="admStoreOption__name">
              <strong>{module.label}</strong>
            </span>
          </label>
        ))}
      </div>
      <span className="admFormHint">
        Tudo o que o Administrador faz, menos os módulos desmarcados. Ele não altera direitos (nem os
        próprios), não cria administradores e não gerencia quem alcança um módulo que ele não tem. A
        mudança vale no próximo login dele.
      </span>
    </div>
  );
};

export default RevokedModulesPicker;
